import styled from 'styled-components';

const Separator = styled.hr`
  border: 0;
  border-top: ${props => `1px solid ${props.theme.separator.color}`};
  width: 100%;
`;

export default Separator;
